
import { Action } from 'redux';
import { CheckoutActionTypes } from '../checkout.types';
import { ACTION_CREATOR_NAME } from 'helpers';

export interface ClearLoginAuthErrorsAction extends Action<CheckoutActionTypes.CLEAR_LOGIN_AUTH_ERRORS> {
}

export const clearLoginAuthErrors: () => ClearLoginAuthErrorsAction = () => ({
    type: CheckoutActionTypes.CLEAR_LOGIN_AUTH_ERRORS
});
clearLoginAuthErrors[ACTION_CREATOR_NAME] = 'clearLoginAuthErrors';

export type ClearLoginAuthErrorsFunc = (...args: Parameters<typeof clearLoginAuthErrors>) => void;